import { useEffect, useState } from "react";
import { PartyPopper, Clock } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "./ui/dialog";
import { SOCIAL_NETWORKS } from "./SocialIcons";
import { ShareAdButton } from "./ShareAdButton";
import { useLanguage } from "../context/LanguageContext";

const KEY = "cp-follow-prompt-off";

export const FollowPrompt = ({ listing, open, onClose }) => {
  const { t } = useLanguage();
  const [links, setLinks] = useState({});
  useEffect(() => {
    if (!open) return;
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/site/social`).then((r) => r.json()).then(setLinks).catch(() => {});
  }, [open]);
  if (localStorage.getItem(KEY)) return null;
  const shown = SOCIAL_NETWORKS.filter((n) => links[n.id]);
  const never = () => { localStorage.setItem(KEY, "1"); onClose(); };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md rounded-3xl bg-white text-center p-8" data-testid="follow-prompt">
        <span className="mx-auto h-14 w-14 rounded-2xl bg-[#FFF4F0] flex items-center justify-center"><PartyPopper size={28} className="text-[#F5551E]" /></span>
        <DialogTitle className="font-display font-extrabold text-2xl text-[#12234A] mt-3">{t("fp_title")}</DialogTitle>
        <DialogDescription className="text-slate-500 text-sm">{shown.length ? t("fp_follow") : t("fp_share_only")}</DialogDescription>
        {shown.length > 0 && (
          <div className="flex justify-center gap-3 mt-2" data-testid="follow-prompt-social">
            {shown.map(({ id, label, Icon }) => (
              <a key={id} href={links[id]} target="_blank" rel="noopener noreferrer" aria-label={label} data-testid={`follow-prompt-${id}`}
                className="h-12 w-12 rounded-full bg-[#12234A] text-white flex items-center justify-center hover:bg-[#F5551E] hover:scale-110 transition-[background-color,transform]">
                <Icon size={20} />
              </a>
            ))}
          </div>
        )}
        <div className="mt-5 rounded-2xl bg-slate-50 p-4 text-left">
          {listing.status === "active" ? (
            <div className="flex items-center gap-3">
              <ShareAdButton listing={listing} testid="follow-prompt-share" />
              <p className="text-sm text-[#12234A] font-semibold">{t("fp_share_now")}</p>
            </div>
          ) : (
            <p className="flex items-start gap-2 text-sm text-slate-600" data-testid="follow-prompt-pending"><Clock size={16} className="text-amber-500 mt-0.5 shrink-0" /> {t("fp_pending")}</p>
          )}
        </div>
        <div className="flex justify-center gap-4 mt-5 text-sm">
          <button type="button" onClick={onClose} className="font-semibold text-[#12234A] hover:text-[#F5551E]" data-testid="follow-prompt-close">{t("fp_close")}</button>
          <button type="button" onClick={never} className="text-slate-400 hover:text-slate-600" data-testid="follow-prompt-never">{t("fp_never")}</button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
